var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"hidden":_vm.hidePage}}),_vm._v(" "),_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}]}),_vm._v(" "),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1099b936","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 